export const PROJECT_NAME = 'Tina Mart'; // can change
export const BASE_URL = process.env.REACT_APP_API_URL;
export const WEBSITE_URL = '';
export const api_url = BASE_URL + '/api/v1/';
export const api_url_admin = BASE_URL + '/api/v1/dashboard/admin/';
export const api_url_admin_dashboard = BASE_URL + '/api/v1/dashboard/';
export const IMG_URL = '';
export const export_url = BASE_URL + '/storage/';
export const example = BASE_URL + '/';
export const defaultCenter = { lat: 9.0181032, lng: 38.7367438 }; // can change

export const MAP_API_KEY = process.env.REACT_APP_MAP_API_KEY || '';

export const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY || '';
export const API_KEY = process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyDDEQVl0dS4Mq3zlvtQ-ss3VxkLgvsd58g';
export const AUTH_DOMAIN = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'react-redux-d0f95.firebaseapp.com';
export const PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID || 'react-redux-d0f95';
export const STORAGE_BUCKET = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'react-redux-d0f95.appspot.com';
export const MESSAGING_SENDER_ID = process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '745210326206';
export const APP_ID = process.env.REACT_APP_FIREBASE_APP_ID || '1:745210326206:web:346507d7567b5d4a8502ef';
export const MEASUREMENT_ID = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'G-ZZEXE69KBM';
export const DYNAMIC_LINK_DOMAIN = '';
export const ANDROID_PACKAGE_NAME = '';
export const IOS_BUNDLE_ID = '';

export const RECAPTCHASITEKEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LexQvkqAAAAALY4s8QDcGUZIpBay6wwfQ6uLgD7';
// till here

export const SUPPORTED_FORMATS = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/svg+xml',
  'image/svg',
  'image/avif',
];
